<template>
  <div v-if="idProject === 'P3rw1Un80Yz3'">
    <nav-bar></nav-bar>
    <div class="container">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a @click="$router.push('/restaurants')">{{ CONSTANTS.getCopy('RESTAURANTS_BREADCRUMB') }}</a></li>
          </ul>
        </nav>
        <div class="is-flex-row-center">
          <div class="button is-primary is-left" @click="storeRestaurant">
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span class="is-capitalized">{{ CONSTANTS.getCopy('RESTAURANTS_NEW_RESTAURANT') }}</span>
          </div>
        </div>
        <br>

        <table class="table is-striped is-fullwidth">
          <thead>
            <tr>
              <th class="is-capitalized">{{ CONSTANTS.getCopy('RESTAURANTS_TABLE_HEADER_NAME') }}</th>
              <th class="is-capitalized">{{ CONSTANTS.getCopy('RESTAURANTS_TABLE_HEADER_PLATFORM') }}</th>
              <th class="is-capitalized">{{ CONSTANTS.getCopy('RESTAURANTS_TABLE_HEADER_SMS') }}</th>
              <th class="table-button-column">{{ CONSTANTS.getCopy('RESTAURANTS_TABLE_HEADER_ACTIONS') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="restaurant in restaurants" :key="restaurant.id">
              <td>{{ restaurant.name }}</td>
              <td>{{ restaurant.platform }}</td>
              <td>{{ restaurant.sms }}</td>
              <td>
                <div class="field has-addons">
                  <p class="control">
                    <a @click="updateRestaurant(restaurant.id)" class="button is-warning" title="Editar">
                      <span class="icon"><i class="fas fa-edit"></i></span>
                    </a>
                  </p>
                  <p class="control" @click="deleteRestaurant(restaurant)">
                    <a class="button is-danger" title="Eliminar">
                      <span class="icon"><i class="fas fa-trash-alt"></i></span>
                    </a>
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CONSTANTS from '../../constants'
export default {
  data () {
    return {
      idProject: localStorage.getObject('user.idProject'),
      restaurants: []
    }
  },
  beforeMount () {
    this.getRestaurants()
  },
  methods: {
    storeRestaurant () {
      this.$router.push('/restaurants/store')
    },
    updateRestaurant (restaurant) {
      this.$router.push('/restaurants/' + restaurant + '/update')
    },
    getRestaurants () {
      this.api.post('/RestaurantsGetList').then((response) => {
        this.restaurants = response.restaurants
      })
    },
    deleteRestaurant (restaurant) {
      let message = `¿${CONSTANTS.getCopy('RESTAURANTS_CONFIRM_DELETE_RESTAURANT')} ${restaurant.name}?`
      this.dialog.confirm({ message }).then(() => {
        this.api.post('/RestaurantDelete', {id: restaurant.id}).then(() => {
          this.getRestaurants()
        })
      }).catch(() => { })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Restaurants/Restaurants.vue